import { Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
import Login from './pages/Login'
import ActivityData from './pages/ActivityData'
import ActivityDetail from './pages/ActivityDetail'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import { UserDataProvider } from './components/MyContext'
import NotFound from './pages/NotFound'
import './index.scss'
import './App.scss'
import ForgotPassword from './pages/ForgotPassword'
import 'react-toastify/dist/ReactToastify.css';
import NewTemplate from './pages/NewTemplate'
import Measure from './pages/Measure'
import MeasureDetail from './pages/MeasureDetail'
import DownloadFile from './pages/DownloadFile'
import AccountSettings from './pages/AccoutSettings'
import PrivateRoute from './components/PrivateRoute'
import WaterTreatmentPlants from './pages/WaterTreatmentPlants'
import MeasuresResults from './pages/MeasuresResults'

function App() {
  return (
    <UserDataProvider>
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />

        <Route path='/' element={<PrivateRoute><Home /></PrivateRoute>} />
        <Route path='/home' element={<PrivateRoute><NewTemplate /></PrivateRoute>} />
        <Route path='/activitydata' element={<PrivateRoute><ActivityData /></PrivateRoute>} />
        <Route path='/activityDetail/:campus_id/:fac_id/:years/:id' element={<PrivateRoute><ActivityDetail /></PrivateRoute>} />
        <Route path='/measure' element={<PrivateRoute><Measure /></PrivateRoute>} />
        <Route path='/measureDetail/:campus_id/:fac_id/:years/:id' element={<PrivateRoute><MeasureDetail /></PrivateRoute>} />
        <Route path='/measureResults' element={<PrivateRoute><MeasuresResults /></PrivateRoute>} />
        <Route path='/downloadfile' element={<PrivateRoute><DownloadFile /></PrivateRoute>} />
        <Route path='/account-setting' element={<PrivateRoute><AccountSettings /></PrivateRoute>} />

        <Route path='/watertreatmentplants/:campus_id/:fac_id/:years/:id' element={<PrivateRoute><WaterTreatmentPlants /></PrivateRoute>} />

        <Route path='*' element={<NotFound />} />
      </Routes>
    </UserDataProvider>
  )
}

export default App